import { useState } from "react";
import { Layout } from "ui-components/Layout";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { SubmitButton } from "ui-components/Form";
import { formRender, initialValues, companyValidations } from "./company-schema";
import CompanyInfo from "./components/CompanyInfo";
import { useMutation } from "@tanstack/react-query";
import { createCompany } from "services/data.internal.service";
import { Success, Error_ } from "ui-components/Alert";

function AddCompany() {
  const [alert, setAlert] = useState(null);
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  const createCompanyMutation = useMutation(createCompany, {
    onSuccess: (data) => setAlert(<Success data={data} onChange={setAlert} />),
    onError,
  });
  const form = useForm({ defaultValues: initialValues, resolver: yupResolver(companyValidations) });

  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
  } = form;

  const infoProps = { formRender, control, errors };

  const onSubmit = (data) => {
    createCompanyMutation.mutate(data, { onSuccess: () => reset() });
  };
  return (
    <Layout>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <CompanyInfo {...infoProps} />
        <SubmitButton label="Submit" disabled={isSubmitting} url="/setup/company" />
      </form>
    </Layout>
  );
}

export default AddCompany;
